import { useQuery } from '@tanstack/react-query'
import { LobsterMasterApi } from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { labelMasterQueryKeys } from './queryKeys'

export const useQueryLabels = (labelMasterId: string) => {
  return useQuery({
    queryKey: labelMasterQueryKeys.labels.byLabelMaster(labelMasterId),
    queryFn: () =>
      baseClient
        .getApi(LobsterMasterApi)
        .getInternalLabelsByLabelInspection({ labelMasterId }),
    retry: 0,
    gcTime: 0,
    throwOnError: true,
  })
}
